import { Controller } from "@hotwired/stimulus"
import { getCloudFrontKeyPairId } from "../vendor/cloudfront-utils.js"

// Connects to data-controller="image-loader"
export default class extends Controller {
  static targets = ["image", "cover"]
  static values = {
    itemUrl: String,
    policy: String,
    signature: String,
    keyPairId: String,  // Optional - falls back to meta tag if not provided
    buffer: { type: Number, default: 25 }
  }

  // Get keyPairId from data attribute if provided, otherwise from meta tag
  get keyPairId() {
    return this.hasKeyPairIdValue ? this.keyPairIdValue : getCloudFrontKeyPairId()
  }

  connect() {
    this.loadImage()
  }

  loadImage() {
    if (!this.hasItemUrlValue) return

    const item = this.itemUrlValue.split('/')[1].replace(".png", "")
    const cover = document.getElementById(item)
    const target = document.getElementById(item + "-alt")

    if (!cover || !target) return

    let buffer = this.bufferValue
    // Check if item ends with a number
    if (isNaN(parseInt(item.charAt(item.length - 1)))) {
      buffer = 0
    }

    // Set target width based on cover's parent container (4 levels up)
    let coverParent = cover.parentElement
    for (let i = 0; i < 3; i++) {
      if (coverParent) {
        coverParent = coverParent.parentElement
      }
    }

    if (coverParent) {
      const parentWidth = coverParent.getBoundingClientRect().width
      const targetWidth = parentWidth - buffer
      target.style.width = `${targetWidth}px`
      cover.style.width = `${targetWidth}px`
    }

    // Build CloudFront signed URL
    const imageUrl = `https://cdn.lsatengine.com/Questions/${this.itemUrlValue}?Policy=${this.policyValue}&Signature=${this.signatureValue}&Key-Pair-Id=${this.keyPairId}`
    target.src = imageUrl

    // Set cover height when image loads
    target.onload = () => {
      const targetWidth = target.getBoundingClientRect().width
      const ratio = targetWidth / target.naturalWidth
      cover.style.height = `${(target.naturalHeight * ratio) + 1}px`
    }
  }
}
